import * as React from 'react';
import { Link } from 'react-router';

import { useRoutes } from 'js/lib/useRouter';

import { Button } from '@coursera/cds-core';

import { useDegreeDescriptionEventingContext } from 'bundles/degree-description/providers/DegreeDescriptionEventingProvider';
import { buildNavigationLink, getCurrentNavItem, getNavigationItems } from 'bundles/degree-description/utils/utils';

import _t from 'i18n!nls/degree-description';

type Props = {
  slug: string;
  variantOverride?: 'primary' | 'secondary' | 'ghost';
};

export const TAKE_A_COURSE_HASH = '#takeACourse';

const TakeACourseBtn = ({ slug, variantOverride }: Props) => {
  const routes = useRoutes();

  const parentNavRoute = routes[routes.length - 2].name;
  const currentNavRoute = routes[routes.length - 1].name;
  const currentNavItem = getCurrentNavItem(getNavigationItems(), currentNavRoute);

  // Routes to /degrees/{slug}#takeACourse
  const relativePathToOverviewUpsellsSection = buildNavigationLink(slug, '', parentNavRoute);
  // Either leaves the route as blank (for overview) or does a relative route, for the link's href tag.
  // Also adds the hash at the end to go to upsells section
  const hrefWithHashString = `${
    currentNavItem?.isIndexPage ? '' : relativePathToOverviewUpsellsSection
  }${TAKE_A_COURSE_HASH}`;

  // Route object for react router, to make JS-only routing work
  const hrefPathname = { pathname: relativePathToOverviewUpsellsSection, hash: TAKE_A_COURSE_HASH };
  const { trackClickButton } = useDegreeDescriptionEventingContext();

  const handleOnClick = () => {
    trackClickButton('view_stackability_courses', 'eoi');

    const upsellsElmPos = document.getElementById('takeACourse')?.offsetTop ?? 0;
    if (upsellsElmPos !== 0) {
      window.scrollTo({ top: upsellsElmPos, behavior: 'smooth' });
    }
  };

  return (
    <Button
      component={Link}
      variant={variantOverride ?? 'secondary'}
      fullWidth
      href={hrefWithHashString}
      to={hrefPathname}
      onClick={handleOnClick}
    >
      {_t('Explore more courses')}
    </Button>
  );
};

export default TakeACourseBtn;
